import { FC } from 'react'
import type { TUniversity } from '../../types'
import UniversityItem from './components/university-item'
import { cn } from '@src/design-system/helpers'

const ContactInformation: FC<{ university: TUniversity, modal?: boolean }> = ({ university, modal = true }) => {
    return (
        <div className={cn('space-y-4 p-4 m-4 mt-0 bg-white rounded-xl', !modal && 'm-0 p-0')}>
            <p className='font-semibold text-gray-800'>Contact Information</p>
            <div className={cn('grid gap-3', modal ? 'grid-cols-1' : 'sm:grid-cols-2 lg:grid-cols-3')}>
                <UniversityItem label='Contact Name' value={university?.main_contact_name ?? '—'} />
                <UniversityItem label='Email' value={university?.main_contact_email ?? '—'} />
                <UniversityItem label='Phone Number' value={university?.main_contact_phone ?? '—'} />
            </div>
        </div>
    )
}

export default ContactInformation